export enum IUserRole {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
  NONE = "NONE",
}

export interface IOrganization {
  id: number;
  name: string;
  photoUrl?: string;
  groups: any[];
  userRole: IUserRole;
  libraryId?: number;
}
